'use memo';

import { createFileRoute, useParams } from '@tanstack/react-router';

import { HStack, VStack } from '@/components/Layout';
import NavigationCard, {
  type NavigationSectionGroup,
} from '@/components/Navigation/NavigationCard';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ScopeNodeLineageCard } from '../-components/ScopeNodeLineageCard';

export const Route = createFileRoute(
  '/_stacktrace/products/$id/scope/$nodeId/_layout/',
)({
  component: ScopeNodeDetailIndex,
});

function ScopeNodeDetailIndex() {
  const { id, nodeId } = useParams({
    from: '/_stacktrace/products/$id/scope/$nodeId/_layout/',
  });
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'products.detail.tabs',
  });
  const sections: NavigationSectionGroup[] = [
    {
      titleLabel: t('productScope'),
      to: '/products/$id/scope/$nodeId',
      hash: 'scope',
    },
  ];
  return (
    <div className="p-6">
      <HStack className="gap-6 items-start">
        <div className="sticky top-6 max-w-60">
          <NavigationCard sections={sections} />
        </div>
        <VStack className="gap-6 w-full min-w-0">
          <div id="scope">
            <ScopeNodeLineageCard productId={id} nodeId={nodeId} />
          </div>
        </VStack>
      </HStack>
    </div>
  );
}
